import React from 'react';
import NavBar from './navBar'

const Info = () => {
    const data = [
        {
            "question": "What is a Carrington Event",
            "link": "https://en.wikipedia.org/wiki/Carrington_Event"
        },
        {

            "question": "How to survive a solar storm",
            "link": "https://whatifshow.com/how-to-survive-a-solar-storm/"
        }

    ]
    return(
        <div>
            <NavBar/>
            <h1>Creating Awareness about geomagnetic storms</h1>
            <ul>
                {
                    data.map((id) => {
                        return(
                            <li key={id}>
                                
                                <a href={id.link} target="blank">
                                    <h3>
                                    {id.question}
                                    </h3>
                                    </a>
                            </li>
                        )
                    })
                }
            </ul>
        </div>
    )
}

export default Info